import * as React from "react";
import { Dreams } from "./Dreams";
import Hyperlink from "../../Shared/Link/Hyperlink";
import Glyphicon from "../../Shared/Glyphicon/Glyphicon";
import { EGlyphicon } from "../../Shared/Glyphicon/EGlyphicon";
import { StyleClassAuto } from "../../Shared/Styles/Auto/StyleClassAuto";

export function EssayLink({ dreams }: { dreams: Dreams }) {
    const { searchText } = dreams.state;

    const matchingRecord = essayLinks.find((el) => el.hashTag === searchText);

    if (!matchingRecord) {
        return null;
    }

    return (
        <div style={{ margin: `5px` }}>
            <Hyperlink whenClicked={() => {}} to={matchingRecord.link}>
                <Glyphicon icon={EGlyphicon.pencil} />
                <span style={{ marginLeft: `8px` }}>essay</span>
            </Hyperlink>
        </div>
    );
}

const essayLinks = [
    {
        hashTag: `#p_isolation`,
        link: `https://essay.app/essays/13c1aa08709a4018bef0698ab247e415`,
    },
    {
        hashTag: `#money`,
        link: `https://essay.app/essays/6695003ffe7c4cfa94ddb65a9eeed8f9`,
    },
    {
        hashTag: `#p_mind`,
        link: `https://essay.app/essays/2c417ec131a94a649963302f22252026`,
    },
    {
        hashTag: `#p_boredom`,
        link: `https://essay.app/essays/7f3eab864b614baaa5d2c37b5cf7d7e4`,
    },
    {
        hashTag: `#p_porn`,
        link: `https://essay.app/essays/b78f048d1694462e93f194f74933dae9`,
    },
    {
        hashTag: `#p_fat`,
        link: `https://essay.app/essays/815323440d1447d09e8bbc25a0d07c7f`,
    },
];
